// NewCardModal.jsx
import React from 'react';
import DarkButtonWithIcon from "components/common/button/DarkButtonWithIcon";
import { AddIcon } from 'icons/materialIcons';
import { Box } from '@mui/material';

const NewCardModal = ({ isOpen, onClose, onCreate, anchorEl }) => {
  if (!isOpen) return null;

  const modalStyle = {
    position: 'absolute',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '1rem',
    width: '90%',
    maxWidth: '20rem',
    textAlign: 'center',
    boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.1)',
    transform: 'translateX(-50%)',
  };

  if (anchorEl) {
    const anchorRect = anchorEl.getBoundingClientRect();
    modalStyle.top = `${anchorRect.bottom + 10}px`;
    modalStyle.left = `${anchorRect.left + anchorRect.width / 2}px`;
  }

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
      }}
      onClick={handleOverlayClick}
    >
      <Box
        sx={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <DarkButtonWithIcon
            text="Create New Card"
            icon={<AddIcon />}
            iconPosition="start"
            onClick={onCreate}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NewCardModal;